<script setup>
  import { ref, onMounted, watchEffect } from 'vue';
  import BaseModal from './base/BaseModal.vue';

  const showModal = defineModel('showModal', { default: false });
  const emits = defineEmits(['close', 'confirm']);
  const props = defineProps({
    show: {
      type: Boolean,
      default: false
    },
    deviceLabel: {
      type: String,
      default: 'this device'
    },
  });

  const isDeleting = ref(false);

  function closeModal() {
    showModal.value = false;
    emits('close');
  }

  async function handleConfirm() {
    if (isDeleting.value) return;
    isDeleting.value = true;
    try {
      emits('confirm');
    } finally {
      isDeleting.value = false;
    }
  }

  onMounted(() => {
    watchEffect(() => showModal.value = props.show);
  });
</script>

<template>
  <BaseModal
    v-model="showModal"
    :allowOutsideClick="false"
    @close="closeModal"
  >
    <header class="jwx-modal__header">
      <h2 class="jwx-modal__title">Delete Device?</h2>
    </header>
    <div class="jwx-modal__body">
      <div class="jwx-modal__section">
        <p class="jwx-modal__text">Are you sure you want to delete the <strong>{{ props.deviceLabel }}</strong> device?</p>
      </div>
    </div>
    <div class="jwx-modal__footer">
      <div class="jwx-modal__actions">
        <button
          type="button"
          @click.prevent="closeModal"
          class="jwx-button"
        >
          Cancel
        </button>
        <button
          type="button"
          @click.prevent="handleConfirm"
          class="jwx-button"
          data-type="danger"
          :disabled="isDeleting"
        >
          Delete
        </button>
      </div>
    </div>
  </BaseModal>
</template>
